import * as Common from '@/agiles/common';
export  enum StateTypes{
    OtherStatus =0, //変更
    EntryStatus =1, //維持
    ExitStatus = 2, //維持
    AutoStatus = 4, //追加
    UserStatus = 8, //変更       
}

  export class WorkflowState extends Common.ObjectBase{
        constructor(){
        super('WorkflowState');
    } 
      public id: number=0;   
      public workflowId: number=0;
      public workflowStateId:number=0;
      public name: string='';
      // public sectionIdFrom: number=0;
      // public sectionIdTo: number=0;
      public type: StateTypes = StateTypes.UserStatus;
      
      public sectionId:number = 0;
      // public get sectionId():number{
      //   return this.sectionIdFrom;
      // }
      
      // public set sectionId(value:number){
      //   if (this.isLoaded){
      //     this.sectionIdFrom = value;
      //     this.sectionIdTo =  value;
      //   }
      // }

      public get label() : string{
        return this.name;
        // if (this.sectionIdFrom == this.sectionIdTo){
        //   return this.name + ' (区間' + this.sectionIdFrom + ')';
        // } else {
        //   return this.name + ' (区間' + this.sectionIdFrom + ' -> 区間' + this.sectionIdTo + ')';
        // }
      }
  }
  


// export class WorkflowActionQuery extends Common.LoadQuery {
//   constructor() {
//     super('WorkflowActionQuery', WorkflowAction);
//     this.sort = 'id';
//   }
// }

